import React from 'react';
import { useTranslation } from 'react-i18next';
import Head from 'next/head';
import Script from 'next/script';
import { withAuth } from '../../models/functions/with-auth';

export const Maintenance: React.FC = () => {
    const { t, i18n } = useTranslation();
    return (
        <div className="monery-maintenance">
            <Head>
                <meta name="robots" content="noindex, follow" key="robots" />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={`https://monery.io`} />
                <meta property="og:image" content={`https://monery.io/images/social-covers/monery.jpg`} />
                <meta property="twitter:card" content="summary_large_image" />
                <meta property="twitter:url" content={`https://monery.io`} />
                <meta property="twitter:image" content={`https://monery.io/images/social-covers/monery.jpg`} />
                <title>
                    {t('pages.error.maintenance.meta.title')}
                    {t('meta.title.suffix')}
                </title>
                <meta name="description" content={t('pages.error.maintenance.meta.description')} />
                <meta property="og:title" content={t('pages.error.maintenance.meta.title')} />
                <meta property="og:description" content={t('pages.error.maintenance.meta.description')} />
                <meta property="twitter:title" content={t('pages.error.maintenance.meta.title')} />
                <meta property="twitter:description" content={t('pages.error.maintenance.meta.description')} />
            </Head>
            <header className="monery-maintenance__header">
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img src="/html/monery.svg" alt="Monery" width="150" height="26" />
                <a className="monery-maintenance__support" href="https://monery.zendesk.com/hc/cs">
                    {t('pages.error.maintenance.support')}
                </a>
            </header>
            <main className="monery-maintenance__content">
                <section className="monery-maintenance__hero" aria-labelledby="maintenance-title">
                    <div>
                        <h1 id="maintenance-title" className="monery-maintenance__title">
                            {t('pages.error.maintenance.title')}
                        </h1>
                        <p className="monery-maintenance__description monery-maintenance__desktop-description">
                            {t('pages.error.maintenance.gameIntro')}
                        </p>
                        <p className="monery-maintenance__description monery-maintenance__mobile-description">
                            {t('pages.error.maintenance.mobileIntro')}
                        </p>
                        <button
                            type="button"
                            className="monery-maintenance__reload"
                            onClick={() => window.location.reload()}
                        >
                            {t('pages.error.maintenance.reload')}{' '}
                            <svg aria-hidden="true" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M20 7v5h-5M20 12a8 8 0 1 0-2.3 5.7"
                                    stroke="currentColor"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </button>
                    </div>
                    {/* eslint-disable-next-line @next/next/no-img-element */}
                    <img
                        className="monery-maintenance__motif"
                        src="/html/maintenance-update.svg"
                        alt=""
                        width="480"
                        height="320"
                    />
                </section>
                <section className="monery-maintenance__game" aria-label="Monery minihra">
                    {React.createElement(
                        'monery-maintenance-game',
                        { lang: i18n.language?.startsWith('en') ? 'en' : 'cs' },
                        <p className="monery-maintenance__fallback">{t('pages.error.maintenance.gameFallback')}</p>,
                    )}
                </section>
            </main>
            <Script src="/html/maintenance-game.js?v=touch-2" strategy="afterInteractive" />
        </div>
    );
};

export default withAuth(Maintenance);
